import { defaultMemberFormDisplayText } from '../../../subcomponents/member-form/types/display-text';
/**
 * Default display labels for the Update Member Details Form component.
 */
export const defaultUpdateMemberDetailsFormDisplayText = Object.assign(Object.assign({}, defaultMemberFormDisplayText), { submitButtonLabel: 'Update details', formSubmittedMessage: 'Your details have been updated.', errorFailedToSaveTitle: 'Failed to update your details.' });
